const companyName = (
  process.env.REACT_APP_COMPANY ||
  process.env.REACT_APP_COMPANY_NAME ||
  "MITCO"
).trim();
const companySlug = companyName.toLowerCase();
const isProTireCompany = /protire/i.test(companyName);

export const hubConfig = {
  appName: `${companyName.toUpperCase()} HUB`,
  brandIcon: isProTireCompany
    ? `${process.env.PUBLIC_URL || ""}/protire-favicon.png`
    : `${process.env.PUBLIC_URL || ""}/mitco-favicon.png`,
  subtitle: "Centralized access to core areas",
  authCheckPath: "/users/check_login/",
  authLogoutPath: "/users/logout/",
  navButtons: [
    {
      id: "ops",
      permKey: "ops",
      label: "Operations",
      description: "Operations tools and management",
      path: "/ops/",
      subMenus: [
        {
          id: "ops-shipments",
          permKey: "shipments",
          label: "Shipments",
          path: "/ops/receiving",
        },
        {
          id: "ops-purchasing",
          permKey: "purchasing",
          label: "Purchasing",
          path: "/ops/purchasing",
        },
        {
          id: "ops-fulfillment",
          permKey: "fulfillment",
          label: "Fulfillment",
          path: "/ops/fulfillment/print-orders",
        },
        {
          id: "ops-adjustments",
          permKey: "adjustments",
          label: "Adjustments",
          path: "/ops/adjustments",
        },
      ],
    },
    {
      id: "csa",
      permKey: "csa",
      label: "Customer Service and Sales",
      description: "Customer service and sales",
      path: "/csa/",
      subMenus: [
        {
          id: "csa-orders",
          permKey: "orders_nd_quotes",
          label: "Orders & Quotes",
          path: "/csa/customer-orders",
        },
        {
          id: "csa-credits",
          permKey: "credits_and_claims",
          label: "Credits & Claims",
          path: "/csa/customer-credits",
        },
        {
          id: "csa-purchase",
          permKey: "purchasing",
          label: "Purchasing",
          path: "/csa/purchasing",
        },
        {
          id: "csa-invoices",
          permKey: "invoices",
          label: "Invoices",
          path: "/csa/accounts-receivable",
        },
      ],
    },
    {
      id: "csfa",
      permKey: "csfa",
      label: "Customer Facing Sales",
      description: "Customer facing sales",
      path: "/csfa/",
      subMenus: [],
    },
    {
      id: "it-mgr",
      permKey: "it_mgr",
      label: "IT Support",
      description: "IT support, projects, and analytics",
      path: "/mitch/",
      subMenus: [
        {
          id: "it-support",
          permKey: "it_support",
          label: "IT Support",
          path: "/mitch/it-support",
        },
        {
          id: "it-projects",
          permKey: "projects",
          label: "Projects",
          path: "/mitch/project-management",
        },
        {
          id: "it-team",
          permKey: "team_center",
          label: "Team Center",
          path: "/mitch/team-center",
        },
        {
          id: "it-analytics",
          permKey: "analytics",
          label: "Analytics",
          path: "/mitch/system-analytics",
        },
        {
          id: "it-health",
          permKey: "ithealth",
          label: "IT Health",
          path: "/mitch/it-health",
        },
      ],
    },
    {
      id: "portal",
      permKey: "portal",
      label: "Portal",
      description: "Open the customer portal login",
      redir: `https://portal.${companySlug}.com`,
      subMenus: [],
    },
    {
      id: "main-site",
      permKey: "main_site",
      label: "Main Site",
      description: "Open the company website login",
      redir: `https://${companySlug}.com`,
      subMenus: [],
    },
  ],
};

export default function RoutesConfig() {
  return <></>;
}
